import { useUser } from "./contexts/UserContext";
import CharacterCreator from "./pages/CharacterCreator";

import { Commands } from "./pages/Commands";
import LoadingPage from "./pages/LoadingPage";
import { Rules } from "./pages/Rules";
import { Shop } from "./pages/Shop";
import { usePixl } from "./contexts/PixlContext";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";

import "./App.css";
import { AdminConfig } from "./pages/AdminConfig";
import { ActivityFeed } from "./pages/ActivityFeed";
import { ArtCollection } from "./pages/ArtCollection";
import Tracker from "./pages/RedeemTracker";
import HunterFashion from "./pages/HunterFashion";
import HunterFashionEditor from "./pages/HunterFashionEditor";
import HunterFashionCollection from "./pages/HunterFashionCollection";

export default function App() {
    // We need to get the user information to know if
    // the user is logged in or not.
    const user = useUser()?.user;
    const pixlReady = usePixl()?.pixlReady;

    if (!pixlReady) return <LoadingPage />;

    return (
        <BrowserRouter>
            <nav>
                <Link to="/avatar"></Link>
                <Link to="/commands"></Link>
                <Link to="/artcollection"></Link>
                <Link to="/hunterfashion"></Link>
                <Link to="/hunterfashion/editor"></Link>
                <Link to="/rules"></Link>
                {import.meta.env.DEV && <Link to="/shop"></Link>}
                {user && user.isModerator && (
                    <>
                        <Link to="/admin/config"></Link>
                        <Link to="/admin/activityfeed"></Link>
                        <Link to="/admin/tracker"></Link>
                    </>
                )}
            </nav>
            <Routes>
                <Route path="/" element={<Commands />} />
                <Route path="/avatar" element={<CharacterCreator />} />
                <Route path="/artcollection" element={<ArtCollection />} />
                <Route path="/commands" element={<Commands />} />
                <Route
                    path="/hunterfashion/outfit/:outfitId"
                    element={<HunterFashion />}
                />
                <Route
                    path="/hunterfashion/editor"
                    element={<HunterFashionEditor />}
                />
                <Route
                    path="/hunterfashion/editor/:outfitId"
                    element={<HunterFashionEditor />}
                />
                <Route
                    path="/hunterfashion/collection"
                    element={<HunterFashionCollection />}
                />
                <Route
                    path="/hunterfashion/collection/:userId"
                    element={<HunterFashionCollection />}
                />
                <Route path="/rules" element={<Rules />} />
                {import.meta.env.DEV && (
                    <Route path="/shop" element={<Shop />} />
                )}
                {user.isModerator && (
                    <>
                        <Route path="/admin/config" element={<AdminConfig />} />
                        <Route
                            path="/admin/activityfeed"
                            element={<ActivityFeed />}
                        />
                        <Route path="/admin/tracker" element={<Tracker />} />
                    </>
                )}
            </Routes>
        </BrowserRouter>
    );
}
